// [sc-49210] Tabelle senza scroll orizzontale: restano solo le colonne
// principali (classe .col-secondary nascosta in App.css) e il clic sulla riga
// apre una modale con tutti i campi, su tutti gli schermi.

// Controlli della riga che hanno già un'azione propria: il clic su di loro
// non deve aprire anche il dettaglio.
const INTERACTIVE = "button, a, input, select, textarea, label, .actions-cell";

export function shouldOpenRowDetails(event) {
  const target = event?.target;
  if (!target || !target.closest) return false;
  return !target.closest(INTERACTIVE);
}
